import type { HubNotification, WaitingRequest } from '../api/notifications';

export type NotificationsState = { waiting: WaitingRequest[]; updates: HubNotification[] };

type Listener = () => void;

let state: NotificationsState | null = null;
const listeners = new Set<Listener>();

// One poll fills this; the bell, the landing banner and the sidebar count all read from it.
export const notificationsStore = {
  get: (): NotificationsState | null => state,
  set(next: NotificationsState | null): void {
    if (next === state) return;
    state = next;
    for (const listener of listeners) listener();
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
